var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAddSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 1.25195C8.80228 1.25195 9.25 1.69967 9.25 2.25195V5.25195H12.25C12.8023 5.25195 13.25 5.69967 13.25 6.25195C13.25 6.80424 12.8023 7.25195 12.25 7.25195H9.25V10.252C9.25 10.8042 8.80228 11.252 8.25 11.252C7.69772 11.252 7.25 10.8042 7.25 10.252V7.25195H4.25C3.69772 7.25195 3.25 6.80424 3.25 6.25195C3.25 5.69967 3.69772 5.25195 4.25 5.25195H7.25V2.25195C7.25 1.69967 7.69772 1.25195 8.25 1.25195Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26756 8.50195L3.25 19.8158C3.24749 21.4366 4.55429 22.752 6.16717 22.752H12.9695C13.2271 22.752 13.4741 22.6493 13.6564 22.4664L20.4645 15.6387C20.6473 15.4553 20.75 15.2065 20.75 14.947V4.18357C20.75 2.56449 19.4439 1.25195 17.8328 1.25195H10.5V4.00195H12.25C13.4926 4.00195 14.5 5.00931 14.5 6.25195C14.5 7.49459 13.4926 8.50195 12.25 8.50195H10.5V10.252C10.5 11.4946 9.49264 12.502 8.25 12.502C7.00736 12.502 6 11.4946 6 10.252V8.50195H3.26756ZM12.5673 20.796L18.8043 14.541H14.0673C13.2389 14.541 12.5673 15.2126 12.5673 16.041V20.796Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAddSolidStandard);
export default __webpack_public_path__ + "static/media/file-add-solid-standard.57b23a01e88e7bf824128934d694d4b1.svg";
export { ForwardRef as ReactComponent };